module.exports = "<div>\n  <ng2-smart-table [settings]=\"settings\" [source]=\"source\">\n  </ng2-smart-table>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/history-task/history-task.component.html
// module id = ./src/app/shared/history-task/history-task.component.html
// module chunks = main